module.exports = __webpack_public_path__ + "media/images/result_sets/circles/5r6n8n7n-5d582fc5f0e4f054fdfa855e538f497e.svg";